import { createElement, PureComponent } from 'react';
import { node, string, bool } from 'prop-types';
import { css, withTheme } from 'reakit/styled';
import { palette } from 'styled-tools';
import _get from 'lodash/get';
import styled from '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends, e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized } from '../chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _Code from './styled.js';
import SyntaxHighlighter, { registerLanguage } from 'react-syntax-highlighter/prism-light';
import defaultTheme from './theme.js';
import javascript from 'react-syntax-highlighter/languages/prism/javascript';
import jsx from 'react-syntax-highlighter/languages/prism/jsx';
import json from 'react-syntax-highlighter/languages/prism/json';

var Code = function Code(_ref) {
  var children = _ref.children,
      className = _ref.className,
      codeClassName = _ref.codeClassName,
      isBlock = _ref.isBlock,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "codeClassName", "isBlock"]);

  return createElement(_Code, _extends({
    block: isBlock
  }, props), children);
};
var codePropTypes = {
  children: node.isRequired,
  className: string,
  codeClassName: string,
  isBlock: bool
};
Code.propTypes = codePropTypes;
var codeDefaultProps = {
  className: undefined,
  codeClassName: undefined,
  isBlock: false
};
Code.defaultProps = codeDefaultProps;
var C = Code;

var Wrapper = styled(Box).withConfig({
  displayName: "HighlightedCode__Wrapper",
  componentId: "kn73h9-0"
})(["", ";"], function (props) {
  return props.showLabel && css(["position:relative;&:before{color:", ";content:'", "';font-family:'SF Mono','Segoe UI Mono','Roboto Mono',Menlo,Courier,monospace;font-size:0.8rem;font-weight:bold;position:absolute;right:0.5rem;top:0.2rem;text-transform:uppercase;}"], palette('text'), function (props) {
    return props.lang;
  });
});
var highlightedCodePropTypes = {
  children: node.isRequired,
  className: string,
  codeClassName: string,
  isBlock: bool,
  lang: string.isRequired,
  showLabel: bool,
  showLineNumbers: bool
};
var highlightedCodeDefaultProps = {
  className: undefined,
  codeClassName: undefined,
  isBlock: false,
  showLabel: false,
  showLineNumbers: false,
  theme: {}
};
var HighlightedCode =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(HighlightedCode, _React$PureComponent);

  function HighlightedCode() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      registerLanguage('javascript', javascript);
      registerLanguage('jsx', jsx);
      registerLanguage('json', json);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          className = _this$props.className,
          codeClassName = _this$props.codeClassName,
          isBlock = _this$props.isBlock,
          lang = _this$props.lang,
          showLineNumbers = _this$props.showLineNumbers,
          theme = _this$props.theme,
          props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "codeClassName", "isBlock", "lang", "showLineNumbers", "theme"]);

      var style = defaultTheme({
        palette: _get(theme, 'fannypack.palette')
      });
      return createElement(Wrapper, _extends({
        lang: lang
      }, props), createElement(SyntaxHighlighter, {
        className: className,
        codeClassName: codeClassName,
        block: isBlock,
        language: lang,
        showLineNumbers: showLineNumbers,
        style: style,
        PreTag: C,
        wrapLines: true
      }, children));
    });

    return _this;
  }

  return HighlightedCode;
}(PureComponent); // @ts-ignore

_defineProperty(HighlightedCode, "propTypes", highlightedCodePropTypes);

_defineProperty(HighlightedCode, "defaultProps", highlightedCodeDefaultProps);

var C$1 = withTheme(HighlightedCode);

export { C as a, highlightedCodePropTypes as b, highlightedCodeDefaultProps as c, HighlightedCode as d, C$1 as e, codePropTypes as f, codeDefaultProps as g };
